/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SelectMultiIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Select Multi',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.62842,8.39464c-.33496-.24414-.80371-.17188-1.04834.16211l-3.07477,4.19824-1.0141-1.30566c-.25439-.32715-.7251-.38477-1.05225-.13281-.32715.25488-.38623.72559-.13232,1.05273l1.62402,2.09082c.01715.02197.04315.03052.06219.05029.02991.03125.0506.06885.08673.09521.02643.01929.05658.02759.08453.04297.02393.01318.04602.02588.07104.03613.09314.03906.18939.06543.28729.06543h.00098c.10095,0,.19995-.02808.29535-.06934.02667-.01172.0498-.02563.07513-.04028.02942-.01685.0614-.02637.08899-.04761.03583-.02783.05579-.06641.08514-.09912.01807-.01953.04364-.02832.05988-.05029l3.66211-5c.24463-.33398.17236-.80371-.16162-1.04883Z"
      fill="currentColor"
    />
    <path
      d="M15.75,18.0001H7.25c-1.24072,0-2.25-1.00977-2.25-2.25V7.2501c0-1.24023,1.00928-2.25,2.25-2.25h8.5c1.24072,0,2.25,1.00977,2.25,2.25v8.5c0,1.24023-1.00928,2.25-2.25,2.25ZM7.25,6.5001c-.41357,0-.75.33691-.75.75v8.5c0,.41309.33643.75.75.75h8.5c.41357,0,.75-.33691.75-.75V7.2501c0-.41309-.33643-.75-.75-.75H7.25Z"
      fill="currentColor"
    />
    <path
      d="M2.75,13.7501c-.41406,0-.75-.33594-.75-.75V4.2501c0-1.24023,1.00928-2.25,2.25-2.25h8.75c.41406,0,.75.33594.75.75s-.33594.75-.75.75H4.25c-.41357,0-.75.33691-.75.75v8.75c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
  </svg>`;
};
